var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiasIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#F4F7FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1641_21503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3125 12.0781L25.4375 12.5469V14.4688C22.5401 14.6929 19.8181 15.945 17.7625 17.9992C15.7069 20.0534 14.4529 22.7746 14.2269 25.6719H12.3125V27.5469H14.2344C14.4585 30.4443 15.7106 33.1663 17.7648 35.2219C19.8191 37.2775 22.5402 38.5314 25.4375 38.7575V40.6719H27.3125V38.75C30.2099 38.5259 32.9319 37.2738 34.9875 35.2195C37.0431 33.1653 38.2971 30.4442 38.5231 27.5469H40.4375V25.6719H38.5156C38.2915 22.7744 37.0394 20.0524 34.9852 17.9968C32.9309 15.9412 30.2098 14.6873 27.3125 14.4612V12.0781ZM26.375 16.2969C29.11 16.2969 31.7331 17.3834 33.667 19.3173C35.601 21.2513 36.6875 23.8743 36.6875 26.6094C36.6875 29.3444 35.601 31.9674 33.667 33.9014C31.7331 35.8354 29.11 36.9219 26.375 36.9219C23.64 36.9219 21.0169 35.8354 19.083 33.9014C17.149 31.9674 16.0625 29.3444 16.0625 26.6094C16.0625 23.8743 17.149 21.2513 19.083 19.3173C21.0169 17.3834 23.64 16.2969 26.375 16.2969ZM26.375 21.9219C25.1318 21.9219 23.9395 22.4157 23.0604 23.2948C22.1814 24.1739 21.6875 25.3662 21.6875 26.6094C21.6875 27.8526 22.1814 29.0449 23.0604 29.9239C23.9395 30.803 25.1318 31.2969 26.375 31.2969C27.6182 31.2969 28.8105 30.803 29.6896 29.9239C30.5686 29.0449 31.0625 27.8526 31.0625 26.6094C31.0625 25.3662 30.5686 24.1739 29.6896 23.2948C28.8105 22.4157 27.6182 21.9219 26.375 21.9219Z",
    fill: "#0066CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1641_21503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiasIcon);
export default __webpack_public_path__ + "static/media/biasIcon.843761635893d160e78c1fbdc9281b0b.svg";
export { ForwardRef as ReactComponent };